import React, { useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import Grid from "@material-ui/core/Grid";
import Switch from "@material-ui/core/Switch";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import swal from "sweetalert";
import { _get, _post, rootUrl } from "../Api";

const useStyles = makeStyles((theme) => ({
  centered: {
    // position: 'fixed',
    // top: '50%',
    // left: '50%',
    // transform: 'translate(-50%, -50%)'
  },
  item: {
    marginTop: 11,
  },
}));

const fetchData = (id, callback) => {
  _get("/nova/ta_merchant/" + id)
    .then((res) => {
      callback(res);
    })
    .catch((e) => {
      swal({
        title: "Oops!",
        text: "Something went wrong.",
        icon: "error",
      });
      callback(null, e);
    });
};

export default function QuickSettings(props) {
  const classes = useStyles();
  const [minPickupTime, setMinPickupTime] = useState(0);
  const [restaurantOpen, setRestaurantOpen] = React.useState(false);
  const [dialog, setDialog] = React.useState(false);
  const [loading, setLoading] = React.useState(true);
  const [id] = React.useState(useParams().id);
  const [changeAmount, setChangeAmount] = React.useState(5);
  const [key, setKey] = React.useState(undefined);
  const [name, setName] = React.useState("");

  if (loading && !key) {
    if (localStorage.getItem("access_token")) {
      setKey(localStorage.getItem("access_token"));
    } else {
      let searchParams = new URLSearchParams(window.location.search);
      if (typeof searchParams.get("email") === "string" && typeof searchParams.get("password") === "string") {
        let bodyFormData = new FormData();
        bodyFormData.set("email", searchParams.get("email"));
        bodyFormData.set("password", searchParams.get("password"));

        axios
          .post(rootUrl + "/nova/api/auth", bodyFormData, {
            withCredentials: true,
            headers: {
              "Content-Type": "multipart/form-data",
              Accept: "application/json",
              Authorization: "Bearer ",
            },
          })
          .then(function (response) {
            //handle success
            let token = response.data.data.access_token;
            localStorage.setItem("access_token", token);
            setKey(token);
          })
          .catch(function (response) {
            swal({
              title: "Oops!",
              text: "Something went wrong.",
              icon: "error",
            });
          });
      }
    }
  }

  if (loading && key) {
    fetchData(id, function (result, err) {
      setLoading(false);
      setMinPickupTime(result.data.minimum_pickup_minutes);
      setChangeAmount(result.data.minutes_per_block);
      setName(result.data.merchant.name);
      setRestaurantOpen(!!result.data.active);
      if (err) {
        console.log(err);
      }
    });
    return (
      <div align="center">
        <CircularProgress color="primary" />
      </div>
    );
  }

  const handleClickOpen = () => {
    setDialog(true);
  };
  const handleClose = () => {
    const newValue = !restaurantOpen;

    _post("/nova/ta_merchant/quick/" + id, {
      minimum_pickup_minutes: minPickupTime,
      active: newValue,
    })
      .then((res) => {
        setRestaurantOpen(newValue);
      })
      .catch((e) => {
        swal({
          title: "Oops!",
          text: "Something went wrong.",
          icon: "error",
        });
      });
    setDialog(false);
  };

  const increase = () => {
    const newAmount = minPickupTime + changeAmount;

    _post("/nova/ta_merchant/quick/" + id, {
      minimum_pickup_minutes: newAmount,
      active: restaurantOpen,
    })
      .then((res) => {
        setMinPickupTime(newAmount);
      })
      .catch((e) => {
        swal({
          title: "Oops!",
          text: "Something went wrong.",
          icon: "error",
        });
      });
  };

  const decrease = () => {
    if (minPickupTime > changeAmount - 1) {
      const newAmount = minPickupTime - changeAmount;
      _post("/nova/ta_merchant/quick/" + id, {
        minimum_pickup_minutes: newAmount,
        active: restaurantOpen,
      })
        .then((res) => {
          setMinPickupTime(newAmount);
        })
        .catch((e) => {
          swal({
            title: "Oops!",
            text: "Something went wrong.",
            icon: "error",
          });
        });
    }
  };

  if (dialog) {
    return (
      <Dialog
        style={{ position: "inherit" }}
        onClose={() => setDialog(false)}
        aria-labelledby="customized-dialog-title"
        open={dialog}
      >
        <DialogActions>
          <Button autoFocus onClick={() => setDialog(false)} color="secondary">
            Cancel
          </Button>
          <Button autoFocus onClick={handleClose} color="primary">
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  function OpenCloses() {
    if (restaurantOpen) {
      return <Typography style={{ color: "green" }}>Restaurant is geopend</Typography>;
    } else {
      return <Typography style={{ color: "red" }}>Restaurant is gesloten</Typography>;
    }
  }

  return (
    <div className={classes.centered}>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          {name}
        </Grid>
        <Grid item xs={4}>
          Huidige Wachttijd:{" "}
        </Grid>
        <Grid item xs={3}>
          <IconButton onClick={decrease}>
            <RemoveIcon />
          </IconButton>
        </Grid>

        <Grid item xs={2} className={classes.item}>
          <Typography>{minPickupTime}</Typography>
        </Grid>

        <Grid item xs={2}>
          <IconButton onClick={increase}>
            <AddIcon />
          </IconButton>
        </Grid>

        <Grid item xs={9}>
          <OpenCloses />
        </Grid>
        <Grid item xs={3}>
          <Switch onChange={handleClickOpen} checked={restaurantOpen} size="small" color="primary" />
        </Grid>
      </Grid>
    </div>
  );
}
